export const NOTIFICATION_MESSAGE_CLOSE_TIMEOUT = 5000;

export const RUSSIAN_LANG_ID = 1;
export const ENGLISH_LANG_ID = 2;
